export default {
	/**
	 * Check if a node is blocked for processing.
	 *
	 * @param {JQuery Object} $node
	 * @return {bool} True if the DOM Element is UI Blocked, false if not.
	 */
	isBlocked: function ($node) {
		return $node.is('.blocker.blocked') || $node.parents('.blocker.blocked').length;
	},

	/**
	 * Block a node visually for processing.
	 *
	 * @param {JQuery Object} $node
	 * @param {...string} [classes]
	 */
	block: function ($node, ...classes) {
		classes.unshift('blocker', 'blocked');
		classes = classes.join(' ');
		$node.addClass(classes).data('blocker-classes', classes);
	},

	/**
	 * Unblock a node after processing is complete.
	 *
	 * @param {JQuery Object} $node
	 */
	unblock: function ($node) {
		$node.removeClass($node.data('blocker-classes') || '').removeData('blocker-classes');
	}
};